import React, { FormEvent, useRef, useState } from 'react'
import { MultiLineTextWithValidation, SlideOutModalProps, TextWithValidation } from '../../../../../components'
import { Button, Form } from 'react-bootstrap';
import sharedProperty from '../../../../../app/sharedProperty';
import { DisciplineModel } from '../../../../../data/entities';

interface DisciplineDetailsProps {
  dataItemState: sharedProperty<DisciplineModel>;
  onSubmit: (data: DisciplineModel) => void;
  props: SlideOutModalProps;
}

function DisciplineDetails({ onSubmit, dataItemState, props }: Readonly<DisciplineDetailsProps>) {

  
  const [validated, setValidated] = useState(false);

  const formRef = useRef<HTMLFormElement>(null);
  const formSubmitRef = useRef<HTMLButtonElement>(null);

  const patchDataItem = (patch: Object) => {
    dataItemState.setter({ ...dataItemState.value, ...patch });
  }

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setValidated(true);
      props.onSubmit.call(null, dataItemState.value);
      setValidated(false);
    } else {
      setValidated(false);
    }
  };

  return (
    <>
      <Form ref={formRef} noValidate validated={validated} onSubmit={handleSubmit}>  
        <div className="col-12">
          <TextWithValidation
            id="name"
            required={true}
            label="Name"
            initialValue={dataItemState.value.name}
            onChangeText={(v) => patchDataItem({ name: v })}
          /> 
        </div>
        <div className="col-12">
          <TextWithValidation
            id="code"
            required={true}
            label="Code"
            initialValue={dataItemState.value.code}
            onChangeText={(v) => patchDataItem({ code: v })}
          />
        </div>
        <div className="col-12">
          <MultiLineTextWithValidation
            id="description"
            required={false}
            label="Description"
            initialValue={dataItemState.value.description}
            onChangeText={(v) => patchDataItem({ description: v })}
          />
        </div>
        <Button ref={formSubmitRef} type="submit" className="d-none" />
      </Form>
      <div className="container p-0">
        <div className="row g-0">
          <div className="col-6 pe-2">
            <Button onClick={() => props.showState.setter(false)} variant="cancel" className="w-100">
              Cancel
            </Button>
          </div>
          <div className="col-6 ps-2">
            <Button onClick={() => formSubmitRef.current?.click()} variant="primary" className="w-100">
              Update
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}

export default DisciplineDetails
